import {Divider, Form as AntForm} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {FC, ReactNode, useState} from 'react';

import {SimpleActionButton} from 'components/form/components';

import s from './filter-form.module.less';

interface IFilterFormProps {
    children: ReactNode;
    handleSubmit: (filters?: Record<string, any>) => void;
    handleEdit?: (filters?: Record<string, any>) => void;
    handleReset?: () => void;
    title?: string;
}

export const FilterForm: FC<IFilterFormProps> = ({
    children,
    handleSubmit,
    handleEdit,
    handleReset,
    title,
}: IFilterFormProps) => {
    const [form] = useForm<Record<string, any>>();
    const [areParametersApplied, setAreParametersApplied] = useState(false);

    const handleSubmitAction = () => {
        form.validateFields().then(() => {
            handleSubmit(form.getFieldsValue());
            setAreParametersApplied(true);
        });
    };

    const handleEditAction = () => {
        if (handleEdit) handleEdit();
        setAreParametersApplied(false);
    };

    const handleResetAction = () => {
        if (handleReset) handleReset();
        form.resetFields();
    };

    return (
        <div className={s.wrapper}>
            <div className={s.header}>
                <h2 className={s.header__title}>{title || 'Фильтры'}</h2>
                <Divider className={s.header__divider} />
            </div>
            <AntForm
                form={form}
                layout="vertical"
                className={s['filter-form']}
                aria-disabled={areParametersApplied}
            >
                <div className={s['filter-form__filters']}>
                    {children}
                </div>
            </AntForm>
            {areParametersApplied ? (
                <SimpleActionButton
                    type="default"
                    onClick={handleEditAction}
                    title="Редактировать"
                />
            ) : (
                <div className="buttons">
                    <SimpleActionButton
                        type="primary"
                        onClick={handleSubmitAction}
                        title="Применить"
                        disabled={false}
                    />
                    <SimpleActionButton
                        type="default"
                        onClick={handleResetAction}
                        title="Сбросить"
                    />
                </div>
            )}
        </div>
    );
};
